import { keyframes, styled } from "styled-components";
import { ReactComponent as Search } from "../../assets/icons/search2.svg";
import ProgressiveImg from "../../components/ProgressiveImg/ProgressiveImg";

const fadeIn = keyframes`
  from {
    opacity: 0;

  }
  to {
    opacity: 1;

  }
`;

export const HomeContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow-x: hidden;
  height: fit-content;
  min-height: calc(100dvh + 330.5px);
  position: relative;
  background-color: white;
`;

export const HeaderWrapper = styled.div`
  position: fixed;
  z-index: 1000000;
  width: 100%;
  justify-content: center;
`;
export const MainContainer = styled.div`
  flex-direction: ${(props) => (props.$column ? "column" : "row")};
  background: #f6f6f9;
  min-height: 100vh;
  height: 100%;
  display: flex;
`;
export const StyledContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 140px;
  justify-content: center;
  flex-direction: column;
  transition: all 0.3s ease-in-out;
  align-items: center;

  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "4rem 30rem 8rem 4rem"
          : "4rem 4rem 8rem 30rem"
        : !props.$ar
          ? "4rem 4rem 8rem 10rem"
          : "4rem 10rem 8rem 4rem"
      : "4rem 4rem"};

  @media (max-width: 1440px) {
    width: 100%;
  }
  @media (max-width: 1200px) {
    margin-top: 126px;
  }
  @media (max-width: 870px) {
    margin-top: 79px;
    padding: 2rem 2rem 8rem 2rem;
  }
  @media (max-width: 380px) {
    margin-top: 65px;
  }
`;
export const Content = styled.div`
  min-height: calc(100dvh - 330.5px);
  height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6rem;
  max-width: 1440px;

  animation: ${fadeIn} 0.6s ease-in;

  @media (max-width: 1500px) {
    max-width: 100%;
  }
  @media (max-width: 540px) {
    gap: 3rem;
  }
`;
export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${(p) => (p.$marginOff ? "0rem" : "1rem")};
  margin-bottom: ${(p) => (p.$marginOff ? "0rem" : "2rem")};

  @media (max-width: 870px) {
    width: 100%;
  }
`;
export const SearchInput = styled.input`
  width: 83rem;
  height: 4.5rem;
  border-radius: 2.5rem;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 0rem 2rem 0rem 4.5rem;
  outline: none;
  font-size: 1.8rem;
  font-family: "Avenir-Light";

  &:focus {
    border: 1.5px solid #484888;
  }
  &::placeholder {
    color: #48488880;
  }

  @media (max-width: 1030px) {
    width: 65rem;
  }
  @media (max-width: 870px) {
    width: 100%;
  }
`;
export const SearchRelativeContainer = styled.div`
  position: relative;
  display: flex;
  border-radius: 2.5rem;
  background-color: white;
  align-items: center;

  @media (max-width: 870px) {
    width: 100%;
  }
`;
export const SearchIcon = styled(Search)`
  position: absolute;
  cursor: ${(props) => (props.$active ? "pointer" : "default")};
  left: 1rem;

  path {
    fill: ${(props) => (props.$active ? "#484888" : "#5F6368")};
    fill-opacity: ${(props) => (props.$active ? 1 : 0.25)};
  }
`;

export const HeroSection = styled.section`
  border-radius: 2.8rem;
  background: rgba(236, 195, 113, 0.2);
  width: 100%;
  height: 44.8rem;
  padding: 0rem 13rem 0rem 6.4rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  overflow: hidden;
  position: relative;

  @media (max-width: 540px) {
    padding: 2rem;
  }
`;

export const Image = styled(ProgressiveImg)`
  object-fit: contain;
  height: 100%;
  width: auto;
`;
export const StyledCardImage = styled(ProgressiveImg)`
  object-fit: contain;
  height: 100%;
  width: auto;
  display: none;
  @media (max-width: 900px) {
    display: flex;
    position: absolute;
    right: -10rem;
    z-index: 1;

    filter: blur(2px);
    opacity: 0.65;
  }
`;

export const StyledImage = styled(ProgressiveImg)`
  object-fit: contain;
  height: 100%;
  width: auto;
  @media (max-width: 540px) {
    position: absolute;
    right: -10rem;
    z-index: 1;

    filter: blur(2px);
    opacity: 0.65;
  }
`;
export const CardImage = styled(ProgressiveImg)`
  object-fit: contain;
  width: 100%;
  height: 50rem;
  @media (max-width: 700px) {
    position: absolute;

    z-index: 1;
    filter: blur(2px);
    opacity: 0.65;
    height: auto;
  }
`;

export const Title = styled.h1`
  color: #636060;
  font-family: "FrankfurterEF-Medium";
  font-size: ${(props) => (props.$small ? "4.9rem" : "5.4rem")};
  @media (max-width: 540px) {
    text-align: center;
    margin-bottom: 0rem !important;
    margin-top: 0rem !important;
  }
`;

export const Subtitle = styled.h3`
  color: #636060;
  font-family: "Avenir-Medium";
  font-weight: "400";
  font-size: ${(props) => (props.$small ? "2.1rem" : "2.4rem")};
  @media (max-width: 900px) {
    text-align: center;
  }
  @media (max-width: 700px) {
    color: white;
    text-shadow:
      0px 0px 5px rgba(0, 0, 0, 0.35),
      0px 0px 2px rgba(0, 0, 0, 1);
  }
`;
export const StyledTitle = styled.h1`
  color: #636060;
  font-family: "FrankfurterEF-Medium";
  font-size: ${(props) => (props.$small ? "4.9rem" : "5.4rem")};
  @media (max-width: 540px) {
    text-align: center;
    text-shadow:
      0px 0px 10px rgba(0, 0, 0, 0.35),
      0px 0px 2px rgba(0, 0, 0, 1);
    color: white;
  }
`;

export const StyledSubtitle = styled.h3`
  color: #636060;
  font-family: "Avenir-Medium";
  font-weight: "400";
  font-size: ${(props) => (props.$small ? "2.1rem" : "2.4rem")};
  @media (max-width: 540px) {
    text-align: center;
    color: white;
    text-shadow:
      0px 0px 5px rgba(0, 0, 0, 0.35),
      0px 0px 2px rgba(0, 0, 0, 1);
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  z-index: 4;
  @media (max-width: 540px) {
    align-items: center;
    justify-content: center;

    width: 100%;
  }
`;

export const Button = styled.button`
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #484888;
  border-radius: 1rem;
  padding: 0.5rem 2rem;
  width: fit-content;

  color: #fff;
  font-family: "Avenir-Medium";
  font-size: 1.9rem;
  font-weight: "400";
  line-height: 3rem;
  transition: all 0.3s ease-in-out;
  &:active {
    filter: brightness(90%);
    scale: 0.975;
  }
  @media (max-width: 700px) {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  }
  @media (max-width: 540px) {
    font-size: 1.8rem;
  }
`;
export const StyledButton = styled.button`
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #484888;
  border-radius: 1rem;
  padding: 0.5rem 2rem;
  width: fit-content;

  margin-top: ${(props) => (props.$small ? "2rem" : "4rem")};

  color: #fff;
  font-family: "Avenir-Medium";
  font-size: 1.9rem;
  font-weight: "400";
  line-height: 3rem;

  transition: all 0.3s ease-in-out;
  &:active {
    filter: brightness(90%);
    scale: 0.975;
  }
  @media (max-width: 540px) {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  }
`;

export const SectionPopular = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

export const CardTitle = styled.span`
  color: #636060;
  font-family: "FrankfurterEF-Medium";
  font-size: 3.4rem;
  @media (max-width: 900px) {
    text-align: center;
  }
  @media (max-width: 700px) {
    color: white;
    text-shadow:
      0px 0px 5px rgba(0, 0, 0, 0.35),
      0px 0px 2px rgba(0, 0, 0, 1);
  }
`;

export const CardText = styled.span`
  text-align: justify;
  font-family: "Avenir-Medium";
  font-size: 1.8rem;
  font-weight: "300";
  line-height: 4rem; /* 222.222% */
  margin: 3rem 0rem;

  @media (max-width: 900px) {
    text-align: center;
    color: white;
    font-weight: 600;
    margin: 0rem;
    text-shadow:
      0px 0px 5px rgba(0, 0, 0, 0.35),
      0px 0px 2px rgba(0, 0, 0, 1);
  }

  @media (max-width: 400px) {
    line-height: 3rem;
  }
`;

export const SectionPopularRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 3rem;
  width: 100%;
`;
export const SectionPopularCard = styled.div`
  display: flex;
  flex-direction: column;
  background: rgba(243, 242, 243, 0.75);
  border-radius: 4rem;
  padding: 2rem;
  align-items: center;
  justify-content: center;
  gap: 5rem;
  width: ${(props) =>
    props.$big ? "calc((100% - 3rem) / 2)" : "calc((100% - 6rem) / 3)"};
  height: ${(props) => (props.$big ? "104.5rem" : "85.5rem")};
  overflow: hidden;
  position: relative;
  @media (max-width: 900px) {
    width: calc((100% - 3rem) / 2);
    height: 85.5rem;
  }
  @media (max-width: 700px) {
    width: 100%;
    height: 26rem;
  }
  @media (max-width: 500px) {
    width: 100%;

    height: 26rem;
  }
`;

export const CardTitleContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: ${(props) =>
    props.$big ? "5.3rem" : "calc(5.3rem + 1rem + 3.3rem)"};
  flex-direction: column;
  gap: 1rem;
`;
export const Gap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  align-items: center;
  justify-content: center;
  z-index: 4;
  @media (max-width: 700px) {
    gap: 2rem;
  }
`;
export const LowBrightness = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  box-shadow: inset 0px 0px 10px white;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.45) 30%,
    rgba(0, 0, 0, 0) 100%
  );

  z-index: 3;
  @media (max-width: 700px) {
    display: flex;
  }
`;
export const Brightness = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  box-shadow: inset 0px 0px 10px white;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.45) 30%,
    rgba(0, 0, 0, 0) 100%
  );

  z-index: 3;
  @media (max-width: 540px) {
    display: flex;
  }
`;
export const StyledLowBrightness = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  box-shadow: inset 0px 0px 10px white;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.45) 30%,
    rgba(0, 0, 0, 0) 100%
  );

  z-index: 3;
  @media (max-width: 900px) {
    display: flex;
  }
`;
export const SectionCrafts = styled(SectionPopular)`
  @media (max-width: 540px) {
    gap: 3rem;
  }
`;
export const SectionCraftsRow = styled(SectionPopularRow)``;

export const SectionCraftsCards = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) =>
    props.$big ? "calc((100% - 3rem) / 1.65)" : "calc((100% - 3rem) / 2.55)"};
  height: 75rem;

  align-items: center;
  border-radius: 5rem;
  background: #e0dad5;
  padding: 3rem;
  @media (max-width: 900px) {
    display: ${(props) => (props.$none ? "none" : "flex")};
  }
`;

export const StyledSectionCraftsCards = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) =>
    props.$big ? "calc((100% - 3rem) / 1.65)" : "calc((100% - 3rem) / 2.55)"};
  height: 75rem;

  align-items: center;
  border-radius: 5rem;
  background: #e0dad5;
  padding: 3rem;
  @media (max-width: 900px) {
    width: 100%;
    justify-content: center;
    overflow: hidden;
    position: relative;
    height: fit-content;
  }
`;
